import { render, staticRenderFns } from "./CommunityComments.vue?vue&type=template&id=159f062a&scoped=true&"
import script from "./CommunityComments.vue?vue&type=script&lang=js&"
export * from "./CommunityComments.vue?vue&type=script&lang=js&"
import style0 from "./CommunityComments.vue?vue&type=style&index=0&id=159f062a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159f062a",
  null
  
)

export default component.exports